import React from 'react';
import classes from './MainInfo.module.scss';
import { useTranslation } from 'react-i18next';
import { Progress, Statistic } from 'antd';
import colors from 'scss/variables/colors.module.scss';
import { useAppSelector } from 'store/hook';
import analytics from 'api/analytics';
import { IMainInfo, mainInfoDefault } from 'interfaces/AnalyticTypes';
import RowLoader from 'components/Sceletons/RowLoader';

type MainInfoProps = {
  period: [string, string, string];
  choosenRoom?: string;
};

const MainInfo = ({choosenRoom, period}: MainInfoProps) => {
  const [isLoadingMainData, setIsLoadingMainData] = React.useState(false);
  const [mainInfo, setMainInfo] = React.useState<IMainInfo>(mainInfoDefault);

  const { messageApi } = useAppSelector((state) => state.windowState);

  const { t } = useTranslation();

  const members_actual = mainInfo?.max_members_amount - mainInfo?.members_amount_left;

  const getMainInfo = async (period: [string, string, string], room?: string) => {
    setIsLoadingMainData(true);
    try {
      const mainInfo = await analytics.getAnalyticsMainInfo({room, from: period[0], to: period[1]});  
      setMainInfo(mainInfo.data);
    } catch (e) {
      messageApi?.error(t('Analytics.errors.main_info'))
    } finally {
      setIsLoadingMainData(false);
    };
  };

  React.useEffect(() => {
    getMainInfo(period, choosenRoom);
  }, [choosenRoom, period[2]]);
  
  return (
    <div className={classes.section} style={{marginBottom: 15}}>
      <div className={classes.title}>{t('Analytics.section.info')}</div>
      <div className={classes.contentInfo}>
        <div className={classes.contentItem}>
          <div className={classes.itemTitle}>{t('Analytics.info.memory')}</div>
          <Progress
            type='circle'
            strokeColor={colors.primary100}
            size={190}
            percent={Number((mainInfo?.total_document_size / mainInfo?.max_space * 100)?.toFixed(1))}
            format={(percent) => (!isLoadingMainData
              ? (
                <div>
                  <div>{mainInfo?.total_document_size?.toFixed(0)}/{mainInfo?.max_space}{t('Analytics.gb')}</div>
                  <div style={{fontSize: 16, paddingTop: 10}}>{`${percent}%`}</div>
                </div>
              ) : (
              <div>
                <RowLoader height={38} width={100} padding={'0 0 0 0'}/>
                <RowLoader height={24} width={80} padding={'0 0 0 0'}/>
              </div>
            )
          )}
          />
        </div>
        <div className={classes.contentItem}>
          <div className={classes.itemTitle}>{t('Analytics.info.users')}</div>
          <Progress
            type='circle'
            strokeColor={colors.primary100}
            size={190}
            percent={Number((members_actual / mainInfo?.max_members_amount * 100)?.toFixed())}
            format={(percent) => (!isLoadingMainData
              ? (
                <div>
                  <div>{members_actual?.toFixed(0)}/{mainInfo?.max_members_amount}</div>
                  <div style={{fontSize: 16, paddingTop: 10}}>{percent}%</div>
                </div>
              ) : (
                <div>
                  <RowLoader height={38} width={100} padding={'0 0 0 0'}/>
                  <RowLoader height={24} width={80} padding={'0 0 0 0'}/>
                </div>
              ))}
          />
        </div>
        <div className={classes.contentItem}>
          <div className={classes.itemTitle}>{t('Analytics.info.files')}</div>
          {
            isLoadingMainData
             ? <RowLoader height={40} width={140} padding={'0 0 0 0'}/>
             : <Statistic title='' value={mainInfo?.total_document_count} groupSeparator=' '/>
          }

        </div>
      </div>
    </div>
  );
}

export default MainInfo;
